// 新协议
function kkmhhybrid_load_page (opt) {
  console.log(opt)
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "load_page",
    },
    param: {
      // param: {
        app_url: opt.app_url,
        web_url: opt.web_url
      // }
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}
// 旧协议
function kkaction_loadPage (opt) {
  console.log(5555)
  hybrid({
    hybridParam: {
        schema: "kkaction",
        tagname: "loadPage",
    },
    param: {
      appUri: opt.app_url,
      webUri: opt.web_url
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}
/**
 * 加载三方App或者三方app官网Web页面<br>
 * kkmhhybrid://load_page{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=81202484}<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.app_url 三方APP可用时的启动url
 * @param {String} opt.web_url 三方APP不可用时，网页加载Url
 * @param {Function} opt.callback 回调函数
 */
function load_page (opt, criticalAppVersion) {
  if(!criticalAppVersion) {
    criticalAppVersion = window.kkBaseInfo.criticalAppVersion;
  }
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(!allow) {
    // 调用旧协议
    kkaction_loadPage(opt);
  } else {
    // 调用新协议
    kkmhhybrid_load_page(opt);
  }
}

export default load_page;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/load_page/index.js